/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscTrackingDetectRequest = { tracking_number: string };

export const GetMiscTrackingDetectRequest$zodSchema: z.ZodType<
  GetMiscTrackingDetectRequest
> = z.object({
  tracking_number: z.string().describe("需要识别的快递单号。"),
});

/**
 * 无法识别该快递单号。
 */
export type GetMiscTrackingDetectNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscTrackingDetectNotFoundResponseBody$zodSchema: z.ZodType<
  GetMiscTrackingDetectNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("无法识别该快递单号。");

export type Alternative = {
  code?: string | undefined;
  name?: string | undefined;
};

export const Alternative$zodSchema: z.ZodType<Alternative> = z.object({
  code: z.string().optional(),
  name: z.string().optional(),
});

export type GetMiscTrackingDetectData = {
  tracking_number?: string | undefined;
  carrier_code?: string | undefined;
  carrier_name?: string | undefined;
  alternatives?: Array<Alternative> | undefined;
};

export const GetMiscTrackingDetectData$zodSchema: z.ZodType<
  GetMiscTrackingDetectData
> = z.object({
  alternatives: z.array(z.lazy(() => Alternative$zodSchema)).optional(),
  carrier_code: z.string().optional(),
  carrier_name: z.string().optional(),
  tracking_number: z.string().optional(),
});

/**
 * 识别成功！返回识别结果和可能的备选项。
 */
export type GetMiscTrackingDetectResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  data?: GetMiscTrackingDetectData | undefined;
};

export const GetMiscTrackingDetectResponseBody$zodSchema: z.ZodType<
  GetMiscTrackingDetectResponseBody
> = z.object({
  code: z.string().optional(),
  data: z.lazy(() => GetMiscTrackingDetectData$zodSchema).optional(),
  message: z.string().optional(),
}).describe("识别成功！返回识别结果和可能的备选项。");

export type GetMiscTrackingDetectResponse =
  | GetMiscTrackingDetectResponseBody
  | GetMiscTrackingDetectNotFoundResponseBody;

export const GetMiscTrackingDetectResponse$zodSchema: z.ZodType<
  GetMiscTrackingDetectResponse
> = z.union([
  z.lazy(() => GetMiscTrackingDetectResponseBody$zodSchema),
  z.lazy(() => GetMiscTrackingDetectNotFoundResponseBody$zodSchema),
]);
